import React from 'react';
import { SEMANTIC_HR_CONTACT_HREF } from '../../../../content/enterpriseMessaging';

export default function ClosingCTA() {
  return (
    <section className="section">
      <div className="container-x">
        <div className="rounded-2xl bg-brand-wash border border-brand-100 px-8 py-14 sm:px-12 text-center">
          <p className="eyebrow">Get Started</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-ink-900">
            See It on Synthetic Data. Build It in Your Snowflake.
          </h2>
          <p className="mt-5 max-w-2xl mx-auto text-lg text-ink-600 leading-relaxed">
            Explore the reference product on synthetic data, then deploy Semantic HR in your
            Snowflake account.
          </p>
          <div className="mt-8 flex flex-wrap gap-4 justify-center">
            <a href={SEMANTIC_HR_CONTACT_HREF} className="btn-primary btn-lg">
              Request demo
            </a>
            <a href="#metrics" className="btn-secondary btn-lg">
              HR metrics catalog
            </a>
            <a href="#use-cases" className="btn-secondary btn-lg">
              Use cases
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
